// SCRIPTS PAGE
import '../../js/build-common'
import '../../../common/js/utils/canvas'
import '../../../common/js/vendor/air-datepicker/dist/js/datepicker'
import '../../../common/js/vendor/sweetalert/dist/sweetalert.min'
import '../../../common/js/vendor/bootstrap-touchspin/dist/jquery.bootstrap-touchspin'
import '../../../common/js/vendor/bootstrap-maxlength/bootstrap-maxlength.min'
import '../../../common/js/vendor/owl.carousel/dist/owl.carousel'
import '../../../common/js/vendor/slick-carousel/slick/slick.min'
import '../add_quotes/add_quotes'

// STYLES PAGE
import "../CEO_page/ceo_page.sass"

$(window).on('load', function () {
   $('.header').addClass('ready');
});

$(document).ready(function () {
    let documentElement = $(this);

    // language=HTML tracker item template
    let tenderTrackerItemTemplate = documentElement.find('#track').html();

    let tagTemplate = '<a href="" class="tag"><span></span></a>';

    function promiseLoadTendersTracker(url, num) {
        const promise = $.ajax({ url: url, data: { limit: num } });
        return promise
    }

    // get tenders slider
    promiseLoadTendersTracker('/api/quotes/?quote_type=c2e')
        .then(data => {
            for (let i = 0; i < data.results.length; i++) {
                let tenderTemplate = $(tenderTrackerItemTemplate);

                tenderTemplate.find('.flag.departure').css('background-image','url("/static/components/intl-tel-input/flags/'+ data.results[i].departure_country.code +'.svg")');
                tenderTemplate.find('.caption.departure').html(data.results[i].departure_country.name);
                tenderTemplate.find('.flag.destination').css('background-image','url("/static/components/intl-tel-input/flags/'+ data.results[i].destination_country.code +'.svg")');
                tenderTemplate.find('.caption.destination').html(data.results[i].destination_country.name);

                for (let l = 0; l < data.results[i].shipping_method.length; l++) {
                    tenderTemplate.find('.shipping_methods').append('<div class="'+data.results[i].shipping_method[l]+'"><span></span></div>');
                }

                tenderTemplate.find('.track__weight').html(data.results[i].weight_total + ' ' +data.results[i].weight_unit);
                tenderTemplate.find('.track-link').attr('href', data.results[i].detail_url);

                $('#tendersTracker').append(tenderTemplate);
            }
        })
        .then(function () {
            // start carousel in tracker_block
            $('#tendersTracker').slick({
                infinite: true,
                autoplay: true,
                // autoplay: false,
                slidesToShow: 5,
                slidesToScroll: 1,
                marginBottom: 15,
                dots: false,
                nav: false,
                focusOnSelect: true,
                useCSS: true,
                draggable: false,
                swipe: false,
                swipeToSlide: false,
                touchMove: false,
                speed: 1000,
                vertical: true,
                verticalSwiping: true
            });
        })
        .catch(function (e) {
            console.log(e)
        })

    $(function () {
        let $sectionsModal = $('#quote_create .form-section');

        function navigateTo(index) {
            // Mark the current section with the class 'current'
            $sectionsModal
                .removeClass('current')
                .eq(index)
                .addClass('current');
            // Show only the navigation buttons that make sense for the current section:
            $('#quote_create .form-navigation .previous').toggle(index > 0);
            let atTheEnd = index >= $sectionsModal.length - 1;
            $('#quote_create .form-navigation .next').toggle(!atTheEnd);
            $('#quote_create .form-navigation [type=submit]').toggle(atTheEnd);
        }

        function curIndex() {
            // Return the current index by looking at which section has the class 'current'
            return $sectionsModal.index($sectionsModal.filter('.current'));
        }

        // Previous button is easy, just go back
        $('#quote_create .form-navigation .previous').click(function () {
            $('.step-actions').attr('data-step', curIndex() - 1);
            navigateTo(curIndex() - 1);
        });


        // Next button goes forward iff current block validates
        $('#quote_create .form-navigation .next').click(function () {
            $('#quote_create').parsley().destroy();

            let fields = $('.form-section.current').find('.require');
            $.each(fields, function () {
                let field = $(this);

                field.attr({'data-parsley-group':'block-' + curIndex()});

                if(field.hasClass('selectpicker')){
                    if(!field.val()){
                        $('[data-id="pallets_types"]').addClass('parsley-error');
                    }
                }
            });

            $('#quote_create').parsley().whenValidate({
                group: 'block-' + curIndex()
            }).done(function () {
                $('.step-actions').attr('data-step', curIndex() + 1);
                navigateTo(curIndex() + 1);
                window.set_sortable($('.tablinks.active'));
                if($(window).width() < 768){
                    $('html, body').animate({scrollTop: $('#quote_create').offset().top - 80},300)
                }
            });
        });

        // Prepare sections by setting the `data-parsley-group` attribute to 'block-0', 'block-1', etc.
        $sectionsModal.each(function (index, section) {
            $(section).find(':input').attr('data-parsley-group', 'block-' + index);
        });
        navigateTo(0); // Start at the beginning


    });

    $('[name="destination"], [name="departure"]').on('focus', function() {
        $('.js-search-wrapper').find('.input-dropdown ul').html('');
        $(this).closest('.js-search-wrapper').find('.input-dropdown').addClass('active');
    });

    $('[name="destination"], [name="departure"]').on('focusout', function() {
        let item = this;
        setTimeout(function() {
            $(item).closest('.js-search-wrapper').find('.input-dropdown').removeClass('active');
        }, 400);

    });

    $('[name="departure"], [name="destination"]').on('input', function(e) {
        if (e.target.value.length > 1) {
            $(e.target).closest('.js-search-wrapper').find('.input-dropdown ul').html('');
            $(e.target).closest('.js-search-wrapper').find('.input-dropdown').addClass('active');
            $.ajax({
                url: ''+window.url+'',
                type: 'GET',
                data: {
                    search: e.target.value
                },
                success: function(r) {
                    $(e.target).closest('.js-search-wrapper').find('.input-dropdown ul').html('');

                    for (let i = 0; i < r.data.length; i++) {
                        let item = $('<li>');
                        item.addClass('city-pick2');
                        item.attr('data-id', r.data[i].id);
                        item.attr('data-country', r.data[i].country);
                        item.attr('data-city', r.data[i].name);
                        item.html(r.data[i].original_address);
                        $(e.target).closest('.js-search-wrapper').find('.input-dropdown ul').append(item);
                    }

                },
                error: function (e) {
                    console.log(e)
                }
            })
        } else {
            $(e.target).closest('.js-search-wrapper').find('.input-dropdown').removeClass('active');
            $(e.target).closest('.js-search-wrapper').find('.input-dropdown ul').html('');
        }
    });

    documentElement.on('click', '.city-pick2', function(e) {
        let item = $(e.target);
        $(e.target).closest('.js-search-wrapper').find('.form-element').val(item.html());
        $(e.target).closest('.js-search-wrapper').find('.country').val(item.attr('data-country'));
        $(e.target).closest('.js-search-wrapper').find('.city').val(item.attr('data-city'));
        $('.js-search-wrapper').find('.input-dropdown').removeClass('active');
    });

    $(this)
        .on('click', '.faq-title', function (e) {
            let neighbors = $(this).closest('.faq-item').siblings();

            neighbors.find('.faq-text').slideUp(300);
            neighbors.find('.faq-title').removeClass('active');
            neighbors.removeClass('active');

            $(this).toggleClass('active');
            $(this).closest('.faq-item').toggleClass('active');
            if($(this).hasClass('active')){
                $(this).closest('.faq-item').find('.faq-text').slideDown(300)
            }else{
                $(this).closest('.faq-item').find('.faq-text').slideUp(300)
            }
        });

    $('#delivery').parsley();

    let item = $('.method-type');
    item.click(function () {
        $(this).toggleClass('active');
        let selectItem = $('.method-type.active');
        if(selectItem.length === 0){
            $(this).addClass('active');
            $.Notification.notify('error', 'top center', '', window.text_1);
        }
    });

    window.sendForm = function () {
        let methods = [],
            departure_country = $('[name="departure-country"]').val(),
            departure_city = $('[name="departure-city"]').val(),
            destination_country = $('[name="destination-country"]').val(),
            destination_city = $('[name="destination-city"]').val();

        if(departure_city.length > 0 && destination_city.length > 0){

            $('#main-departure, #main-destination').removeClass('parsley-error');

            $.each($('.method-type.active'), function () {
                methods.push($(this).attr('data-type'))
            });

            let shipping_method = $('select[name="shipping_method"]');

            shipping_method.selectpicker('refresh');
            shipping_method.selectpicker('val', methods);

            $("[name='departure_country']").val(departure_country);
            $("[name='departure_address']").val(departure_city);
            $("[name='destination_country']").val(destination_country);
            $("[name='destination_address']").val(destination_city);

            $("[name='departure_country']").trigger('change');
            $("[name='destination_country']").trigger('change');

            $('.delivery').css({'display':'none'});
            $('.quote-create').css({'display':'block'});
            $('.step-actions').css({'display':'flex'});

            if($(window).width() < 768) {
                $('html, body').animate({scrollTop: $('#quote_create').offset().top - 80}, 300)
            }

        }else{
            if(departure_city.length <= 0){
                $('#main-departure').toggleClass('parsley-error parsley-success');
                $.Notification.notify('error', 'top center', '', window.errorA);
            }
            if(destination_city.length <= 0){
                $('#main-destination').toggleClass('parsley-error parsley-success');
                $.Notification.notify('error', 'top center', '', window.errorB);
            }
        }

        // window.location = '/quotes/create/?departure_country='+departure_country+'&departure_address='+departure_city+'&destination_country='+destination_country+'&destination_address='+destination_city+'&shipping_method='+methods+''
    };

    if(window.location.search === '?new_reg'){
        $.Notification.notify('success', 'top center', '', window.text_2);
    }

    // rendered blog items
    let windowHeight = $(window).height();
    function promiseBlog(url) {
        const promise = $.ajax({ url: url, method: 'GET' });
        return promise;
    }

    documentElement.on('scroll', function() {
		$('[data-blog]').each(function() {

			let
                self = $(this),
			    height = self.offset().top + self.height();

			if (documentElement.scrollTop() + windowHeight >= height) {
			    let
                    blog_url = self.attr('data-url'),
                    blog_block = self.attr('data-blog');

                self.removeAttr('data-blog');

                promiseBlog(window.blog_url_api + 'posts/?tags=' + blog_url)
                    .then(data => {
                        appendBlock(data, blog_block);
                    })
                    .then(function () {
                        documentElement.find('.'+blog_block)
                            .removeClass('blog-blocks')
                            .addClass('owl-carousel')
                            .owlCarousel({
                                autoplay: false,
                                smartSpeed: 800,
                                dots: false,
                                responsive: {
                                    0: {items: 1,nav: false,margin: 0,loop: true},
                                    768: {items: 2,nav: false,margin: 20,loop: true},
                                    992: {items: 3,nav: true,margin: 20,navText: ['<i class="qv qv_arrow-prev"></i>', '<i class="qv qv_arrow-next"></i>'],loop: false}
                                }
                            });
                    })
                    .catch(err => {
                        console.log(err)
                    });
			}
		});
	});

    function appendBlock(data, wrap) {
        let
            parent = $('body').find('.'+wrap);

        if(data.length > 0){
            parent.empty();

            for(let i=0;i < data.length; i++){
                let
                    id = data[i].id,
                    media = data[i].featured_media,
                    template = $('<div class="blog-item">\n' +
                    '                <div class="image">\n' +
                    '                    <a class="blog-image" href="" target="_blank" rel="nofollow" style="background-image: url()"></a>\n' +
                    '                    <span class="back" style="background-image: url()"></span>\n' +
                    '                </div>\n' +
                    '                <div class="blog-content">\n' +
                    '                    <div><a class="blog-title" href="" target="_blank" rel="nofollow"></a></div>\n' +
                    '                    <a class="blog-detailed" href="" rel="nofollow" target="_blank"><i class="qv qv_info"></i> '+window.textMore+'</a>\n' +
                    '                </div>\n' +
                    '            </div>');

                template.find('a').attr('href', data[i].link);
                template.find('.blog-title').html(data[i].title.rendered);
                template.find('.blog-image').attr('data-blog-image', data[i].id);
                template.find('.back').attr('data-blog-image', data[i].id);
                parent.append(template);

                setImage(id, media);
            }
        }
    }

    function setImage(id, media) {

        let item = $('body').find('[data-blog-image="'+id+'"]');

        promiseBlog(window.blog_url_api + 'media/'+media)
            .then(data => {
                item.css('background-image', 'url('+ data.source_url +')');
            })
            .catch(err => {
                console.log(err)
            });
    };

    $('#owl-partners').owlCarousel({
        loop: false,
        autoplay: false,
        smartSpeed: 800,
        nav: false,
        dots: false,
        items: 2,
        margin: 5
    });

    documentElement
        .on('click', '.modalType2-close', function (e) {
            e.preventDefault();
            $(this).closest('.modalType2').fadeOut(100);
            $('body').removeClass('overflow');
            if(window.player){window.player.stopVideo()}
        })
        .on('click', '[data-toggle="modalType2"]', function (e) {
            e.preventDefault();
            if ($(this).attr('data-target') !== '#contact' !== '#company-detail_info') {
                $('body').addClass('overflow');
                let modal = documentElement.find($(this).data('target'));
                modal.fadeIn(100);
            }
        });

    $('#launch-video').click(function() {
        window.player.playVideo();
    });

    $('.ceo-text-btn').click(function () {
        let $this = $(this);
        let wrap = $('.ceo-text');

        if(wrap.hasClass('active')){
            $this.html($this.data('originalHtml'))
            wrap.removeClass('active')
        }else{
            $this.data('originalHtml', $this.html())
            $this.text(window.textClose)
            wrap.addClass('active')
        }
    })

});


window.openTab2 = function(evt, tabName) {
    let i, tabcontent, tablinks;

    tabcontent = document.getElementsByClassName("tabcontent2");
    for (i = 0; i < tabcontent.length; i++) {
        tabcontent[i].style.display = "none";
    }

    tablinks = document.getElementsByClassName("tablinks2");
    for (i = 0; i < tablinks.length; i++) {
        tablinks[i].className = tablinks[i].className.replace(" active", "");
    }

    document.getElementById(tabName).style.display = "block";
    evt.currentTarget.className += " active";
}

$(window).on('load', function() {
    let tag = document.createElement('script');
    tag.src = "//www.youtube.com/player_api";
    let firstScriptTag = document.getElementsByTagName('script')[0];
    firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

    // Replace the 'ytplayer' element with an <iframe> and
    // YouTube player after the API code downloads.
    window.player = '';

    // russian version of video
    let videoId = 'S_1LN4PO6BA';

    // turkish and eng version of video
    if (window.currentLang === 'ru' || window.currentLang === 'uz') {
        videoId = 'TNRALqUXqII';
    }else if(window.currentLang === 'tr'){
        videoId = 'u17S7GrGsFQ'
    }

    window.onYouTubePlayerAPIReady = function() {
       window.player = new YT.Player('ytplayer', {
           height: '360',
           width: '640',
           videoId: videoId,
           playerlets: {
               controls: 1,
               rel: 0,
               modestbranding: 1,
               showinfo: 0,
           }
       });
    };
});

